import Navbar from "../components/Navbar";
import { useState } from "react";
import API from "../api/api";
import { errorAlert, successAlert, warningAlert } from "../utils/alert";
// import { useNavigate } from "react-router-dom";

const ChangePassword = () => {
  const role = sessionStorage.getItem("role") || localStorage.getItem("role");
  // const navigate = useNavigate();

  const [oldPassword, setOldPassword] = useState("");
  const [emailOtp, setEmailOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [otpSending, setOtpSending] = useState(false);
  const [otpNotice, setOtpNotice] = useState("");

  const handleSendOtp = async () => {
    if (!sessionStorage.getItem("token")) {
      errorAlert("Not logged in", "You are not logged in!");
      return;
    }

    setOtpSending(true);
    try {
      const res = await API.sendPasswordChangeOtp();
      const expiryMinutes = Math.max(1, Math.round(Number(res?.data?.expires_in || 600) / 60));
      setOtpNotice(`OTP sent to your registered email. It stays valid for about ${expiryMinutes} minutes.`);
      successAlert("OTP sent", "Check your registered email for the 6-digit OTP.");
    } catch (err) {
      errorAlert("OTP send failed", err?.message || "Unable to send password change OTP.");
    } finally {
      setOtpSending(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      warningAlert("Password mismatch", "New password and confirm password do not match");
      return;
    }

    if (!sessionStorage.getItem("token")) {
      errorAlert("Not logged in", "You are not logged in!");
      return;
    }

    if (!/^\d{6}$/.test(String(emailOtp || "").trim())) {
      warningAlert("OTP required", "Enter the 6-digit OTP sent to your email.");
      return;
    }

    try {
      await API.changePassword({
        current_password: oldPassword,
        email_otp: emailOtp,
        new_password: newPassword,
        new_password_confirmation: confirmPassword,
      });

      // Success: show toast, clear auth data, then redirect to login.
      successAlert("Password changed", "Password changed successfully. Please log in again.");
      sessionStorage.clear();
      localStorage.clear();

      // Use full reload to clear React state and AuthContext
      setTimeout(() => {
        window.location.href = "/login";
      }, 1500);
    } catch (err) {
      errorAlert("Password change failed", err.message || "Error changing password");
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-100 to-indigo-200">
      <Navbar role={role} />
      <div className="max-w-md mx-auto bg-white rounded-lg shadow-lg mt-20 p-8">
        <h1 className="text-3xl font-bold text-center mb-6 text-indigo-700">
          Change Password
        </h1>

        <form onSubmit={handleSubmit} className="space-y-6">
          <input
            type="password"
            placeholder="Old Password"
            value={oldPassword}
            onChange={(e) => setOldPassword(e.target.value)}
            required
            className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-indigo-400"
          />

          <div className="rounded border border-indigo-200 bg-indigo-50 p-4">
            <div className="flex flex-col gap-3 sm:flex-row">
              <input
                type="text"
                placeholder="Email OTP"
                value={emailOtp}
                onChange={(e) => setEmailOtp(e.target.value.replace(/\D/g, "").slice(0, 6))}
                required
                maxLength={6}
                className="flex-1 px-4 py-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-indigo-400"
              />
              <button
                type="button"
                onClick={handleSendOtp}
                disabled={otpSending}
                className="bg-indigo-600 text-white px-4 py-3 rounded font-semibold hover:bg-indigo-700 transition-colors disabled:bg-indigo-300"
              >
                {otpSending ? "Sending..." : otpNotice ? "Resend OTP" : "Send OTP"}
              </button>
            </div>
            <p className="mt-2 text-sm text-indigo-700">
              {otpNotice || "Request an OTP to your registered email before changing the password."}
            </p>
          </div>

          <input
            type="password"
            placeholder="New Password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
            className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-indigo-400"
          />

          <input
            type="password"
            placeholder="Confirm New Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
            className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-indigo-400"
          />

          <button
            type="submit"
            className="w-full bg-indigo-600 text-white py-3 rounded font-semibold hover:bg-indigo-700 transition-colors"
          >
            Change Password
          </button>
        </form>
      </div>
    </div>
  );
};

export default ChangePassword;
